import {
  Avatar,
  Button,
  Image,
  Input,
  Pagination,
  Select,
  SelectItem,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { ProgessColors } from "../../utils/constant";
import SearchIcon from "../../Images/Search";
import {
  getDataWithFilterUrl,
  StringLimit,
} from "../../controllers/APIController";
import { useNavigate } from "react-router-dom";

const OrgFrameworkInfo = ({
  DataList,
  setDataList,
  TitleText,
  DescriptionText,
  defaultOrgId,
  currentPage,
  setCurrrentPage,
  totalStep,
}) => {
  const [searchText, setSearchText] = useState("");

  const [frameWorkData, setFrameWorkData] = useState([]);
  const [filterDataList, setFilterDataList] = useState([]);

  const navigate = useNavigate();

  const searchHandler = (event) => {
    const text = event.target.value;
    const list = frameWorkData.filter((item) => {
      return item?.attributes?.Name?.toLowerCase()?.includes(
        text?.toLowerCase()
      );
    });
    setSearchText(text);
    setFilterDataList(list);
  };

  useEffect(() => {
    const filteredUrl = `filters[organizations][id][$eqi]=${defaultOrgId}`;

    getDataWithFilterUrl("frameworks", filteredUrl)
      .then((data) => {
        let frameWorkData = data.data;

        setFrameWorkData(frameWorkData);
        setFilterDataList(frameWorkData);
      })
      .catch((err) => {
        // Handle error silently
      });
  }, []);

  return (
    <>
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-neutral-900 mb-2">
          {TitleText || "Framework Selection"}
        </h2>
        <p className="text-neutral-600 text-sm leading-relaxed">
          {DescriptionText ||
            `Choose the reporting frameworks that align with your organization's ESG goals and compliance requirements.`}
        </p>
      </div>
      <div className="flex flex-col space-y-6">
        <div className="w-full">
          <label className="block text-sm font-medium text-neutral-700 mb-2">
            Search Frameworks
          </label>
          <Input
            variant="bordered"
            placeholder="Search framework"
            className="w-full"
            classNames={{
              input: "text-neutral-900",
              inputWrapper: "border-neutral-300 hover:border-neutral-400 focus-within:border-primary-500",
            }}
            startContent={
              <SearchIcon
                className={`text-neutral-400 pointer-events-none flex-shrink-0`}
              />
            }
            value={searchText}
            onChange={searchHandler}
          />
        </div>

        <div className="space-y-4">
          <label className="block text-sm font-medium text-neutral-700">
            Available Frameworks
          </label>
          <div className="min-h-[280px] border border-neutral-200 rounded-lg overflow-hidden shadow-sm">
            <Table
              color="primary"
              aria-label="Framework selection table"
              removeWrapper
              selectionMode="multiple"
              isHeaderSticky
              selectedKeys={new Set(DataList["Select Framework"])}
              onSelectionChange={(event) =>
                setDataList({
                  ...DataList,
                  "Select Framework": Array.from(event),
                })
              }
              classNames={{
                wrapper: "min-h-[200px]",
                th: "bg-neutral-50 text-neutral-700 font-medium",
                td: "py-4",
              }}
            >
              <TableHeader>
                <TableColumn>Name</TableColumn>
                <TableColumn>Description</TableColumn>
                <TableColumn>Action</TableColumn>
              </TableHeader>
              <TableBody
                emptyContent={
                  <div className="flex items-center justify-center font-medium gap-2 text-gray-500">
                    No frameworks found
                  </div>
                }
              >
                {filterDataList?.map((item, index) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell>
                        <div className="flex items-center gap-2">
                          <Avatar
                            className="w-8 h-8 "
                            src="https://i.pravatar.cc/150?u=a042581f4e29026024d"
                          />
                          {StringLimit(item?.attributes?.Name || "", 15)}
                        </div>
                      </TableCell>
                      <TableCell>
                        {StringLimit(item?.attributes?.Description || "", 15)}
                      </TableCell>

                      <TableCell>
                        <div
                          className="text-warning-500 font-semibold cursor-pointer"
                          onClick={() => {
                            window.open(`/framework/${item?.id}`);
                          }}
                        >
                          View
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-8 border-t border-neutral-200 mt-10">
        <div className="text-sm text-neutral-500 font-medium">
          Step {currentPage + 1} of {totalStep}
        </div>
        <div className="flex space-x-3">
          <Button
            variant="ghost"
            size="sm"
            className="text-neutral-600 hover:text-neutral-900 px-4"
            isDisabled={currentPage === 0}
            onClick={() => {
              setCurrrentPage(currentPage - 1);
            }}
          >
            Previous
          </Button>
          <Button
            color="primary"
            size="sm"
            className="bg-primary-600 hover:bg-primary-700 text-white px-6 font-medium"
            onClick={() => {
              setCurrrentPage(currentPage + 1);
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};

export default OrgFrameworkInfo;
